module.exports = __webpack_public_path__ + "img/logo_nba-all-star.7931349b.png";